export async function getClientIP() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Не удалось получить IP:", error);
    return "0.0.0.0";
  }
}

export function generateDeviceFingerprint() {
  const nav = navigator;
  const screen = window.screen;
  const fingerprint = [
    nav.userAgent,
    nav.language,
    screen.width,
    screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    nav.hardwareConcurrency || "unknown",
    nav.deviceMemory || "unknown",
  ].join("###");

  return btoa(unescape(encodeURIComponent(fingerprint)));
}

export function getUserAgent() {
  return navigator.userAgent;
}

export async function generateSignatureData(content) {
  const contentString =
    typeof content === "string" ? content : JSON.stringify(content);

  const encoder = new TextEncoder();
  const data = encoder.encode(contentString);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
